import React from "react";
import SolutionsHeroBanner from "../../components/SolutionsHeroBanner/SolutionsHeroBanner";
import SolutiosnFeatureGrid from "../../components/SolutionsFeatureGrid/SolutionsFeatureGrid";
import SolutionsImageGrid from "../../components/SolutionsImageGrid/SolutionsImageGrid";
import SolutionsMainPoints from "../../components/SolutionsMainPoints/SolutionsMainPoints";
import DemoRequest from "../../components/RequestDemo/RequestDemo";
import { useParams } from "react-router-dom";
const featureImgs = [
  "/assests/solutions-main-ft-img-1.png",
  "/assests/solutions-main-ft-img-2.png",
  "/assests/solutions-main-ft-img-3.png",
];
const otherfeatureImgs = [
  "/assests/solutions/cost.png",
  "/assests/solutions/flexibility.png",
  "/assests/solutions/performance.png",
];
const SolutionsIndividualPage = () => {
  const { slug } = useParams();
  console.log(slug, "------------");

  const data = fetchDataBasedOnSlug(slug);
  // console.log(url,'-------------');

  return (
    <div>
      <SolutionsHeroBanner title={data.title} />
      <SolutionsMainPoints features={data.mainfeatures} />
      <SolutionsImageGrid
        title={data.title}
        content={data.content}
        image={data.contentImage}
      />
      <SolutiosnFeatureGrid features={data.features} />
      <DemoRequest />
    </div>
  );
};
const fetchDataBasedOnSlug = (slug) => {
  // Here you'd typically make a call to an API or use some form of state to get your data
  const dummyData = {
    "SAP Application Support (SAP AMS)": {
      title: "SAP Application Support (SAP AMS)",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Application Support Services",
          description:
            "We guarantee continuous system operation through our SAP AMS help desk.",
        },
        {
          icon: featureImgs[1],
          title: "Consulting Services",
          description: `We provide consultancy services for your new projects with experienced consultants.`,
        },
        {
          icon: featureImgs[2],
          title: "Project Management Services",
          description: `We provide project management services with our expert and experienced PMO office.`,
        },
      ],
      content: [
        `Discover the capabilities of the 'Harmonize SAP Application Management Services'.`,
        `At Sealkloud, we elevate your business processes to the highest level with the 'Harmonize Support Solution.' Bringing together our expert and experienced team, we offer swift and practical solutions.Keep your system secure with the "SAP Application Management Services ( SAP AMS )".`,
        "• SAP AMS Support",
        "• 24/7 Support Service within SLA",
        "• Module Consultancy",
        "• ABAP & Fiori Consultancy",
        "• Basis Consultancy",
        "• Project Management & Support",
        "• Process Management Support",
        "• On-Site and Remote Assistance",
        "• System Integration Support",
        "• Training and Documentation",
      ],
      contentImage: "/assests/solutions/sap-ams.png",
      features: [],
    },
    "SAP S-4 Hana Conversion": {
      title: "SAP S-4 Hana Conversion",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Greenfield",
          description:
            "You achieve the S/4Hana transformation by redesigning your processes with the new implementation.",
        },
        {
          icon: featureImgs[1],
          title: "Brownfield",
          description:
            "With a system conversion, you transition from your existing SAP system to S/4Hana while preserving your existing processes.",
        },
        {
          icon: featureImgs[2],
          title: "Bluefield",
          description:
            "With a hybrid approach, you can utilize both the best practices of S/4Hana and your existing SAP customized applications.",
        },
      ],
      content: [
        "A Step to Take Your Business to the Future: S/4 HANA Transformation",
        "SAP S/4HANA has become the key to transformation in today's business world. Companies now have the opportunity to transition to S/4HANA to gain a competitive advantage, make more informed decisions with data analytics, and increase flexibility.",
        "SAP S/4 HANA is an integrated platform designed to manage traditional business applications more efficiently and quickly. With data analytics and real-time processing capabilities, businesses can make faster and smarter decisions while further optimizing their processes.",
        "Why Should You Transition to S/4HANA?",
        "Real-time Data Analytics: Gain instant insights into the health of your business and make better decisions.",
        "Process Optimization: Process data more quickly and make your business operations more efficient.",
        "Competitive Advantage: Outperform your competitors by working faster and more effectively with S/4HANA.",
        "Flexibility: Quickly adapt to changing business needs and seize new opportunities.",
      ],
      contentImage: "/assests/solutions/sap-4-hana.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Strategic Planning and Consulting",
          description: `Requirement Analysis: Analyzes the customer's current business processes, system configuration, and future goals to develop a customized transformation strategy.
            Roadmap: Develops a phased roadmap for the transition to SAP S/4HANA, minimizing risks and maximizing efficiency during the process`,
        },
        {
          icon: otherfeatureImgs[2],
          title: "System Integration and Implementation",
          description: `Integration with Current Systems: Harmonizes SAP S/4HANA with the customer's existing systems, ensuring seamless data integration and smooth operation of workflows.

Customization and Configuration: Customizes and optimizes SAP S/4HANA according to the customer's specific business requirements.`,
        },
        {
          icon: otherfeatureImgs[2],
          title: "Data Migration and Optimization",
          description: `Data Migration: Manages the transfer of data from the existing system to SAP S/4HANA, ensuring data quality and integrity

Performance Optimization: Provides optimizations according to the latest updates to improve system performance.`,
        },
        {
          icon: otherfeatureImgs[0],
          title: "Training, Support, and Continuous Improvement",
          description: `User Training and Support: Provides comprehensive training to SAP users for effective use of the SAP S/4HANA system

          Post-Go-Live Support and Updates: Offers ongoing consultancy support after the system goes live, ensuring that the systems remain up-to-date and compatible with new business requirements.`,
        },
      ],
    },
    "RISE with SAP": {
      title: "RISE with SAP",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "SAP S/4Hana Cloud",
          description:
            "Accelerated ERP transformation, leveraging the cloud for business growth.",
        },
        {
          icon: featureImgs[1],
          title: "Pay-as-you-go",
          description:
            "RISE with SAP enhances cost understanding via real-time monitoring & payment on SAP Business Tech Platform.",
        },
        {
          icon: featureImgs[2],
          title: "Business Process Intelligence",
          description:
            "Enterprises derive valuable insights through process analysis.",
        },
      ],
      content: [
        "Elevate Your Transformation to the Future: RISE with SAP",
        "RISE with SAP guides your digital transformation, enabling you to evolve your business into a smart enterprise by offering the necessary tools and services under one roof. It propels your business into the future while optimizing costs to secure a competitive advantage.",
        "What Does RISE with SAP Offer to Businesses?",
        "RISE with SAP provides businesses with a comprehensive package for organizational transformation, bolstering their digital journey.",
        "RISE with SAP facilitates transformation across diverse aspects. It offers benefits like process optimization, safeguarding prior investments, providing technological flexibility, and bolstering operational security. The solution empowers businesses to move confidently into the future.",
        "RISE with SAP not only supports the transformation process but also equips businesses with all the tools, services, and guidance needed for their journey towards the future.",
      ],
      contentImage: "/assests/solutions/sap-rise.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Unified Platform",
          description:
            "RISE with SAP,  streamlines operations by consolidating diverse needs onto a singular platform and bolstering agility.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Single Contract",
          description:
            "RISE with SAP, RISE with SAP offers integrated solutions through a single contract, enabling businesses to reduce complexity and enhance efficiency.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "SAP Learning Hub",
          description:
            "RISE with SAP, boosts workforce effectiveness by providing continuous learning and skill development opportunities through SAP Learning Hub.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Cost Saving",
          description:
            "RISE with SAP, delivers cost savings to businesses by optimizing processes and ensuring efficient resource utilization.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "SAP Business Network",
          description:
            "RISE with SAP, offers businesses faster integration and collaboration opportunities through the SAP Business Network .",
        },
      ],
    },
    "SAP S-4Hana Cloud": {
      title: "SAP S-4Hana Cloud",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Real-time Analytics",
          description:
            "Access and analyze all data instantly for faster and more accurate decision-making.",
        },
        {
          icon: featureImgs[1],
          title: "Embedded Best Practices",
          description: "Utilize Industry-Specific Best Practices.",
        },
        {
          icon: featureImgs[2],
          title: "ML-AI Integration",
          description:
            "Utilize smart technologies to automate tasks, gain insights, and enhance process efficiency.",
        },
      ],
      content: [
        "SAP S/4HANA Cloud Solutions",
        "SAP S/4HANA Cloud is an integrated solution specifically designed for in-memory computing. It allows businesses to operate in real-time with live data by bringing together both transactional and analytical data on a single platform. As a cloud-native application, it offers scalability, flexibility, and continuous innovation without the hassle of on-premises infrastructure.",
        "Public Cloud ve Private Cloud",
        "SAP S/4HANA Public Cloud Edition: It is a cost-effective option suitable for businesses with basic standard processes. Updates are performed automatically.",
        "SAP S/4HANA Private Cloud Edition: It offers advanced customization and security, providing a private cloud service.",
        "Advantages of SAP S/4HANA Cloud",
        "Lower Costs: Reduce operational costs by minimizing infrastructure and maintenance needs.",
        "Real-time Data Analytics: Accelerate processes with SAP HANA's in-memory capabilities.",
        "Innovation Adoption: Continuously benefit from regular updates and new features without disrupting operations.",
        "Real-time Insights: Make data-driven decisions across all aspects of your business.",
      ],
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Make Data-Driven Decisions",
          description:
            "With its analytical capabilities, you can transform data into insights, enabling faster and more informed decision-making.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Increase Agility and Innovation",
          description:
            "Enhance your business's agility to shorten return on investment timelines and trigger innovation.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Always Up-to-Date with Advanced Technologies",
          description:
            "Thanks to SAP S/4HANA Cloud's automatic software updates, you can quickly access the latest innovations at all times. Additionally, you can leverage advanced technologies such as machine learning, IoT, and virtual reality",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Rapid Deployment and Global Accessibility",
          description:
            "With SAP S/4HANA Cloud, you can adapt to the growth of your business. The solution enables global enterprises to swiftly implement it in different countries and languages.",
        },
      ],
      contentImage: "/assests/solutions/sap-4-hana-cloud.png",
    },

    "SAP S-4HANA Retail": {
      title: "SAP S-4HANA Retail",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Real-Time Analysis",
          description:
            "Make informed business decisions with instant inventory updates, demand forecasts, and sales reports",
        },
        {
          icon: featureImgs[1],
          title: "Supply Chain Optimization",
          description:
            "Reduce costs and increase sales by having your products in the right place at the right time.",
        },
        {
          icon: featureImgs[2],
          title: "Customer Experience",
          description:
            "Offer personalized promotions and recommendations by deeply analyzing customer habits and preferences.",
        },
      ],
      content: [
        "SAP S/4HANA Retail",
        "Shape the Future of Retail with Integrated Business Processes: SAP S/4HANA Retail offers real-time analytics, optimization, and customer experience.",
        "The Future of Retail",
        "Customer-Centricity: SAP's retail solutions deeply analyze consumer shopping habits, expectations, and preferences. This provides retailers with access to the necessary data to enhance customer satisfaction and create loyalty programs.",
        "Inventory and Supply Chain Management: Real-time inventory management, demand forecasting, and automatic order generation features allow retailers to reduce inventory costs and maximize sales opportunities.",
        "Omni-Channel Experience: Delivers a seamless and integrated shopping experience across various sales channels (in-store, online, mobile, etc.), ensuring a consistent and high-quality service to customers on every platform.",
      ],
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "In-Store Operations",
          description:
            "Optimize your business using store manager dashboards, offer seamless omnichannel experiences, and enhance customer service with real-time inventory and RFID-enabled stock management.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Customer Centric Merchandise Management",
          description:
            "Automate product assortment with adaptive reports, synchronize data globally with suppliers, and implement consistent omnichannel pricing and promotions.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Retail Supply Chain Management",
          description:
            "Optimize limited stock through segmentation, process empty inventory using detailed material lists, and centralize retail operations from manufacturing to store sales on a single platform.",
        },
      ],
      contentImage: "/assests/solutions/sap-4-hana-retail.png",
    },
    "SAP S-4HANA Fashion Vertical Business (FMS)": {
      title: "SAP S/4HANA Fashion Vertical Business (FMS)",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "OmniChannel Management",
          description:
            "Integrate different sales channels seamlessly and enrich the customer experience.",
        },
        {
          icon: featureImgs[1],
          title: "Advanced Planning Tool",
          description:
            "Accurately forecast demand and maintain optimal inventory levels.",
        },
        {
          icon: featureImgs[2],
          title: "Integrated Finance and Logistics",
          description:
            "Enhance business efficiency by bringing together accounting, finance, and logistics processes.",
        },
      ],
      content: [
        "Digital Transformation in the Fashion Industry",
        "The fashion industry, due to its dynamic nature, requires keeping pace with rapidly changing demands, seasons, and trends. SAP S/4HANA Fashion Vertical Business (FMS) ensures fashion businesses remain efficient, innovative, and competitive in this ever-evolving environment.",
        "Discover the Key Features of SAP S/4HANA Fashion Vertical Business (FMS)",
        "Integrated Business Processes: Manage all fashion business processes, from wholesale to retail, manufacturing to supply chain, on a single platform.",
        "Real-Time Insights: Accelerate and optimize decision-making processes with real-time inventory, sales, and customer data.",
        "Omni-Channel Management: Provide a seamless experience across physical stores, online sales, mobile apps, and other channels.",
        "Intelligent Analytics: Gain in-depth insights into future sales forecasts, inventory needs, and customer trends with artificial intelligence and machine learning.",
        "Flexible and Modular Structure: Invest only in the functions you need, thanks to customizable modules that cater to your business's requirements.",
      ],
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Style and Collection Management",
          description:
            "In the fast-paced world of fashion, styles and collections evolve rapidly. The Style and Collection Management feature allows businesses to effectively organize, manage, and track their diverse product styles and entire collections seamlessly. This tool enables designers and product managers to efficiently plan and release new collections, ensuring that they are aligned with market trends and consumer preferences.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Size and Fit Management",
          description:
            "A critical aspect of fashion retail is ensuring that products are available in the sizes and fits that cater to the diverse needs of consumers. Size and Fit Management provides a structured framework for managing size scales, fit descriptions, and size sets. This ensures that inventory levels are appropriately maintained for each size and fit, leading to improved customer satisfaction and reduced stockouts or overstock situations.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Product Data Management",
          description:
            "In the fashion industry, product details — from materials to manufacturing processes — are crucial. The Product Data Management feature ensures that all pertinent information about a product, from its inception to its sale, is meticulously recorded, organized, and easily retrievable. This not only aids in quality control and compliance but also provides invaluable data for marketing and sales strategies.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Merchandise Planning and Forecasting",
          description:
            "Accurate planning and forecasting are paramount to ensure that the right products are available at the right time and in the right quantities. The Merchandise Planning and Forecasting tool uses historical sales data, current market trends, and advanced algorithms to predict future sales and inventory needs. This helps businesses optimize their stock levels, reduce holding costs, and improve their responsiveness to market changes.",
        },
      ],
      contentImage: "/assests/solutions/sap-fashion.jpg",
    },

    "SAP CAR": {
      title: "SAP CAR",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "OmniChannel Management",
          description:
            "Integrate different sales channels seamlessly and enrich the customer experience.",
        },
        {
          icon: featureImgs[1],
          title: "Advanced Planning Tool",
          description:
            "Accurately forecast demand and maintain optimal inventory levels.",
        },
        {
          icon: featureImgs[2],
          title: "Integrated Finance and Logistics",
          description:
            "Enhance business efficiency by bringing together accounting, finance, and logistics processes.",
        },
      ],
      content: [
        "SAP CAR Omnichannel: The Real-Time Revolution in Retail",
        "In today's dynamic retail landscape, it's crucial for businesses to stand out with real-time insights. SAP CAR (Customer Activity Repository) is the answer to mastering the complexity of customer-centric data across multiple channels. It's an integral module of SAP Retail, designed to capture, analyze, and process vast amounts of customer-related data from various sources such as Point of Sale (POS), e-commerce platforms, mobile apps, and social media.",
        "Discover the Power of SAP CAR",
        "Unified Customer View : Attain a holistic understanding of your customer interactions across all channels.",
        "Real-time Analytics : Gain deep insights into customer behavior, preferences, and buying trends for personalized campaigns.",
        "Inventory Mastery : Optimize inventory levels, reduce out-of-stock scenarios, and enhance order fulfillment processes.",
        "Demand Forecasting : Stay ahead of customer demand with predictive analytics for better planning",
        "Seamless Integration : Leverage the strength of SAP's extensive ecosystem with seamless integration capabilities with other SAP solutions.",
      ],
      contentImage: "/assests/solutions/sap-car.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Increasing Sales and Revenue",
          description:
            "By leveraging in-depth insights into customer behavior, you can create targeted campaigns and increase conversion rates through personalized product recommendations based on purchase history.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Inventory Management Optimization",
          description:
            "Real-time inventory information reduces inventory costs and minimizes the risk of product shortages, preventing potential sales losses.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Operational Efficiency",
          description:
            "Integrated analysis of data from various sources reduces manual data entry, minimizes errors, and facilitates quick decision-making with real-time analytics.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Enhancing Customer Experience",
          description:
            "Integrated customer data from all channels enables personalized experiences and increases customer satisfaction by reducing order errors with accurate inventory information.",
        },
      ],
    },
    "SAP CAR POSDTA": {
      title: "SAP CAR POSDTA",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Multi-Channel Data Collection",
          description:
            "CAR POSDTA collects transaction data from retail point of sale (POS) in real-time. This provides retailers with the ability to quickly analyze critical information such as sales performance, inventory status, and customer purchasing habits.",
        },
        {
          icon: featureImgs[1],
          title: "Integration and Compatibility",
          description:
            "CAR POSDTA transfers sales data, financial transaction data, and material movement data to SAP ERP. Additionally, it seamlessly integrates with other SAP modules and third-party systems, along with the ability to provide POS data for different analytical components.",
        },
        {
          icon: featureImgs[2],
          title: "Sales Audit and Data Verification",
          description:
            "The Point of Sale Transaction Engine (PIPE) within the system verifies collected POS data against the master data, conducts sales audits, and performs various checks to identify potential errors or inconsistencies. This ensures data integrity and enhances the efficiency of business processes.",
        },
      ],
      content: [
        "CAR POS Data Transfer and Audit (POSDTA)",
        "CAR POS Data Transfer and Audit (POSDTA) refers to the collection of Point of Sale (POS) transaction data from stores. POS transaction data is stored as transaction logs (TLOG) and processed by the Point of Sale Data Processing Engine (PIPE).",
        "PIPE performs various operations on the received POS transactions, including master data validation, sales auditing, summarizing POS transaction data, and sending it to downstream applications.",
        "In cases where store segmentation is used, not every store can sell every product. Therefore, it is necessary to manage which products are sold in which stores or which products are prohibited in certain stores. To control these processes, the listing method comes into play. With the listing method, a product that was once listed can later be prohibited. Additionally, a product that is prohibited for a store may be returned to the store as a return.",
        "Some of the advantages of the listing method are as follows:",
        "Data Collection : Collect and process transactions sent from stores using PIPE.",
        "Master Data Verification : PIPE validates POS transactions against the master data available in an SAP ERP system.",
        "Auditing : PIPE conducts checks for Duplicate Transaction Numbers, gaps in receipt numbers, balanced sales and tender totals, comparison of receipt data against cash in the drawer, and credit card data.",
        "Sales Auditing : Includes POS Workbench to perform sales auditing activities.",
        "Data Summary : Obtain POS data summaries.",
      ],
      contentImage: "/assests/solutions/sap-posdata.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "SAP S/4Hana Retail Integration",
          description:
            "In CAR POSDTA, sales data, financial transaction data, and material movement data are transferred to SAP S4/HANA using IDocs.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "SAP NetWeaver Business Warehouse",
          description:
            "POS Analytics, Trade Foundation Analytics, and Loss Prevention Analytics can be provided for different analytical components.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Other SAP Applications",
          description:
            "CAR POSDTA, SAP Forecasting and Replenishment, SAP Workforce Management, SAP Demand Management Foundation, and even external credit card payment applications can receive POS transaction data.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Integration with CRM Systems",
          description:
            "SAP CAR POSDTA can associate customer numbers with POS transactions if customer data is available from systems like SAP CRM or other third-party CRM systems",
        },
      ],
    },
    "SAP CAR OAA": {
      title: "SAP CAR Omnichannel Article Availability and Sourcing (OAA)",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Real-time Stock Visibility (Multi-Channel)",
          description:
            "It provides real-time inventory visibility across all retail channels.",
        },
        {
          icon: featureImgs[1],
          title: "Intelligent Sourcing Decisions",
          description:
            "It helps retailers determine which channels to sell orders through.",
        },
        {
          icon: featureImgs[2],
          title: "Enhanced Customer Satisfaction",
          description:
            "It elevates the shopping experience by enabling customers to access products anytime and anywhere they want.",
        },
      ],
      content: [
        "SAP CAR Omnichannel Article Availability and Sourcing (OAA)",
        "SAP CAR Omnichannel Article Availability and Sourcing (OAA) is designed to provide real-time inventory visibility across all channels for retailers. Whether it's in-store, online, or from the warehouse, CAR OAA equips customers and staff with the most accurate product availability information.",
        "Its integration capabilities allow retailers to have a comprehensive toolset to meet modern consumer demands.",
        "Some of the advantages of SAP CAR OAA include:",
        "Integrated Inventory View: The single real source for product availability across stores, online channels, and warehouses. It reduces stock discrepancies and optimizes inventory allocation.",
        "Real-Time Inventory Updates: Reflects inventory changes instantly, such as sales, returns, and restocking. Enhances customer satisfaction by accurately representing stock levels online and in-store.",
        "Enhanced Customer Experience: Reduces missed sales opportunities due to incorrect stock information.",
        "Integration Capabilities: Seamless integration with other SAP solutions, including SAP S/4HANA and SAP CAR.",
      ],
      contentImage: "/assests/solutions/sap-opp.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Increase Sales",
          description:
            "Boost conversion rates and increase sales by informing customers of the real-time stock availability, letting them know where the product they want is always in stock.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Eliminate Stockouts and Overstocks",
          description:
            "Optimize inventory management by providing an integrated, real-time inventory view across all channels, minimizing stockouts and overstock situations.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Increase Customer Loyalty",
          description:
            "Enhance customer trust and loyalty by providing accurate and up-to-date product availability information.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Deliver an Enhanced Customer Experience",
          description:
            "Offer a seamless shopping experience to customers by reducing missed sales opportunities due to incorrect stock information.",
        },
      ],
    },
    "SAP CAR OPP": {
      title: "SAP CAR OPP",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Consistent Customer Experience",
          description:
            "Ensures customers see the same prices and promotions, whether shopping online, on mobile, or in-store.",
        },
        {
          icon: featureImgs[1],
          title: "Real-time Pricing Calculation",
          description:
            "Delivers accurate and instant pricing details based on various factors such as customer segmentation, location, and current promotions.",
        },
        {
          icon: featureImgs[2],
          title: "Segmented Offers",
          description:
            "Allows for targeted promotional campaigns based on customer segments, purchase history, and preferences.",
        },
      ],
      content: [
        "SAP CAR Omnichannel Promotions and Pricing (OPP)",
        "SAP Omnichannel Promotions and Pricing provides retailers with a consistent promotion pricing strategy across all channels. Some of the advantages of SAP CAR OPP are as follows:",
        "Consistent Customer Experience: It ensures that customers see the same prices and promotions when shopping online, on mobile, or in-store.",
        "Real-Time Pricing Calculations: It provides accurate and instant pricing details based on various factors such as customer segmentation, location, and current promotions.",
        "Integration: It seamlessly integrates with other SAP modules, facilitating the use of data across different organizational departments.",
        `Flexibility: It supports various promotion tactics, such as "buy one, get one free," percentage discounts, fixed price discounts, and more.`,
        "Automatic Pricing Decisions: It automates pricing decisions based on predefined rules, considering inventory levels, purchase history, and other factors.",
        "Segmented Offers: It enables targeted promotion campaigns based on customer segments, purchase history, and preferences.",
      ],
      contentImage: "/assests/solutions/sap-opp.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Reduced Errors",
          description:
            "By maintaining a consistent database and automated calculations, the risk of pricing errors and inconsistencies is reduced.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Improved Profitability",
          description:
            "Helps in optimizing promotions for maximum ROI, potentially increasing overall profitability.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Consistency",
          description:
            "SAP OPP is beneficial for retailers aiming for a unified commerce experience, especially where consistency across channels is crucial.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Seamless Integration",
          description:
            "It seamlessly integrates with other SAP modules, providing comprehensive process visibility and data flow.",
        },
      ],
    },

    "SAP Forecast and Replenishment (F&R)": {
      title: "SAP Forecast and Replenishment (F&R)",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Accurate Demand Forecasting",
          description:
            "Align inventory levels with consumer trends using predictive analytics that anticipate market demand, and adapt quickly to changing market conditions.",
        },
        {
          icon: featureImgs[1],
          title: "Efficient Replenishment",
          description:
            "Automate replenishment processes based on accurate predictions and real-time data, ensuring optimal stock levels at all times.",
        },
        {
          icon: featureImgs[2],
          title: "Reduced Inventory Costs",
          description:
            "Minimize holding costs and reduce lost sales opportunities due to out-of-stock situations.",
        },
      ],
      contentImage: "/assests/solutions/sap-supply-demand.jpg",
      content: [
        "SAP Forecast and Replenishment (F&R)",
        "SAP Forecast and Replenishment (F&R), designed to optimize supply chain and inventory management processes, is a powerful application. By integrating advanced forecasting techniques and real-time inventory tracking, SAP F&R helps businesses reduce stockouts, lower excess inventory, and enhance overall customer satisfaction.",
        "Customize replenishment strategies for different product types, seasons, and promotional periods.",
        "Create a more responsive supply chain by involving suppliers and partners in the planning process.",
        "Optimize the replenishment process by tracking inventory in real-time across all channels.",
        `SAP F&R seamlessly integrates with other SAP solutions, including SAP S/4HANA, SAP CAR, and SAP ERP, providing a comprehensive and connected enterprise resource planning ecosystem.`,
      ],
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Demand Modeling",
          description:
            "UDF provides retailers with the ability to create complex demand models based on consumer behaviors, enabling more in-depth analysis of market trends and customer preferences",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Multifactor Analysis",
          description:
            "Using cause-and-effect analyses covering multiple data points, it allows for more accurate sales forecasting for individual stores.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Inventory Optimization",
          description:
            "UDF assists in planning replenishment processes and calculating losses of perishable goods, taking into account current stock levels, sales forecasts, and logistical constraints.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Forecast Quality Analysis",
          description:
            "UDF provides detailed analyses of forecast quality, helping retailers reduce out-of-stock events and improve product availability, forming the basis for continuous improvement.",
        },
      ],
    },
    "Unified Demand Forecast (UDF)": {
      title: "Unified Demand Forecast (UDF)",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Integrated Demand Modeling",
          description:
            "SAP UDF creates detailed demand models for various retail applications and provides sales forecasts at stores through multifactor analysis.",
        },
        {
          icon: featureImgs[1],
          title: "Intelligent Replenishment Planning",
          description:
            "UDF optimizes replenishment processes by considering stock levels, sales forecasts, and logistical constraints, enhancing stock management by anticipating losses of perishable goods.",
        },
        {
          icon: featureImgs[2],
          title: "Quality and Performance Analytics",
          description:
            "By analyzing forecast quality, we continuously make improvements and increase product availability to minimize sales losses.",
        },
      ],
      content: [
        "SAP Unified Demand Forecast (UDF)",
        "SAP Unified Demand Forecast (UDF) is a fundamental component that provides sophisticated demand modeling and forecasting capabilities in the retail sector. Harness the power of SAP HANA to gain deeper insights into shopping behaviors and steer your business with data-driven precision.",
        "Insights derived from UDF's predictive analytics provide a forecast of customer demand.",
        "Multifactor analysis of UDF ensures higher accuracy in sales forecasts, enabling stock optimization.",
        "By using advanced demand forecasts, it ensures optimal stock levels by reducing excess inventory and out-of-stock situations.",
        `With accurate predictions, it reduces sales losses and increases customer loyalty by helping customers find what they need.`,
      ],
      contentImage: "/assests/solutions/sap-supply-demand.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Strategic Analysis",
          description:
            "By analyzing various data points, it accurately predicts future demand.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Customized Solution for the Company",
          description:
            "Monitors stock levels and prevents stockouts by automatically generating replenishment orders.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Expert Integration",
          description:
            "Optimizes stock management by providing replenishment strategies tailored to different business needs.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Continuous Support",
          description:
            "We provide comprehensive training and ongoing support for your team to effectively utilize UDF.",
        },
      ],
    },
    "SAP Demand Data Foundation (DDF)": {
      title: "SAP Demand Data Foundation (DDF)",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Unified Data Aggregation",
          description:
            "Create a single source of truth for insights into all demand by integrating data from sales, customer interactions, market trends, and more.",
        },
        {
          icon: featureImgs[1],
          title: "Advanced Demand Analytics",
          description:
            "Conduct in-depth data analysis and pattern recognition using machine learning and AI, and obtain predictive insights for market responsiveness through strategic planning.",
        },
        {
          icon: featureImgs[2],
          title: "Real-Time Insight and Reporting",
          description:
            "Continuously improve by analyzing forecast quality, and minimize sales losses by enhancing product availability.",
        },
      ],
      content: [
        "SAP CAR Demand Data Foundation (DDF)",
        "SAP CAR DDF is a sophisticated module within the SAP CAR series designed to collect and analyze extensive data from various sources. It provides businesses with a comprehensive view of market demand, empowering them to make strategic, data-driven decisions.",
        "Informed Decision-Making: Create informed business strategies by harnessing the power of comprehensive data analysis.",
        "Improved Forecast Accuracy: Enhance the precision of your demand forecasts with advanced analytics.",
        "Operational Efficiency: Optimize inventory management and supply chain operations by utilizing real-time demand data.",
        `Competitive Advantage: Stay ahead in the market by deeply understanding consumer trends and demands.`,
      ],
      contentImage: "/assests/solutions/sap-supply-demand.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Consulting and Strategic Planning",
          description:
            "We offer planning and consulting services tailored to your business's specific needs, outlining how SAP CAR DDF can be aligned with your objectives.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Seamless Integration",
          description:
            "We integrate SAP CAR DDF seamlessly with your existing systems.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Customization and Training",
          description:
            "We customize SAP CAR DDF to meet the specific needs of your business.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Continuous Support and Development",
          description:
            "To adapt to the evolving needs of your business, we regularly implement updates and improvements in the system.",
        },
      ],
    },
    "SAP Customer Service (SAP CS)": {
      title: "SAP Customer Service (SAP CS) Consulting",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Service Management",
          description:
            "Manage customer requests, service orders, and maintenance activities",
        },
        {
          icon: featureImgs[1],
          title: "Customer Interaction",
          description:
            "Track customer complaints and requests in a centralized system.",
        },
        {
          icon: featureImgs[2],
          title: "Integrated Solutions",
          description:
            "Optimize your business processes with full integration of other SAP modules.",
        },
      ],
      content: [
        "Redefine Your Customer Service",
        "SAP CS (Customer Service) enhances your customer service processes, making them more efficient and effective, thus increasing customer satisfaction. SAP CS solutions optimize customer interactions, improve service management processes, and help resolve customer issues swiftly.",
        "Advanced Service Management: Efficiently manage and track service requests.",
        "Quick Response Times: Enhance satisfaction by responding swiftly to customer requests.",
        "Integration Capability: Achieve full integration with other SAP modules.",
        `Automated Processes: Increase efficiency with automated notifications and follow-ups`,
        "Detailed Reporting: Monitor and analyze service performance with detailed reports.",
        "Proactive Issue Resolution: Identify and resolve customer issues proactively",
        "Flexible Solutions: Respond quickly to changing customer needs.",
        "Mobile Access: Manage customer service processes from mobile devices.",
        "Cost Savings: Reduce costs with automation and efficiency-enhancing features.",
        "High Scalability: Easily scale customer service processes as your business grows",
      ],
      contentImage: "/assests/solutions/sap-cs.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Customer Support and Maintenance Services",
          description:
            "We offer continuous improvement and troubleshooting services after the implementation of SAP CS solutions through our customer support and maintenance services",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Customized Training Programs",
          description:
            "We provide tailored training programs for your company, teaching your teams the effective use of SAP CS solutions to ensure you get the maximum benefit from the system.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Project Management and Consultancy",
          description:
            "We deliver expert consultancy services in the planning, management, and implementation phases of SAP CS projects, ensuring they are completed on time and within budget",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Process Optimization",
          description:
            "We analyze your business processes and optimize them by integrating SAP CS solutions, thereby increasing efficiency and reducing costs.",
        },
      ],
    },
    "SAP Sales and Distribution (SAP SD)": {
      title: "SAP Sales and Distribution (SAP SD) Consulting",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Real-time Data",
          description:
            "Provides real-time information on sales, allowing for quick decision-making.",
        },
        {
          icon: featureImgs[1],
          title: "Pricing",
          description:
            "Allows for the configuration of pricing rules, discounts, and surcharges.",
        },
        {
          icon: featureImgs[2],
          title: "Comprehensive Reporting",
          description:
            "Advanced reporting capabilities enable businesses to gain deep insights into sales performance and customer behavior",
        },
      ],
      content: [
        "SAP - Sales and Distribution Module (SD)",
        "SAP Sales and Distribution (SAP SD) is one of the core modules of SAP's ERP suite. It deals with the processes that help a company integrate with its customers in terms of order-to-cash processes.",
        "Master Data: Maintains data related to customers, materials, pricing, etc., which are essential for the order-to-cash process.",
        "Sales Order Management: Manages customer orders, from order creation to delivery.",
        "Delivery Processing: Deals with the shipment and delivery of items once a sales order has been placed.",
        `Billing: Handles the billing process after the delivery of goods.`,
        "Credit Management: Monitors and manages customer credit limits.",
        "Pricing: Allows for the configuration of pricing rules, discounts, and surcharges.",
        "Foreign Trade: Handles international business processes like export and import procedures.",
        "Transportation: Manages the logistics involved in transporting goods to the customer.",
        "Reporting: Offers comprehensive reporting tools for sales analytics.",
        "Flexibility: Adaptable to various business scenarios and industries",
        "Scalability: Can support both small businesses and large enterprises",
      ],
      contentImage: "/assests/solutions/sap-cs.jpg",
      features: [
        {
          icon: otherfeatureImgs[0],
          title: "Integration",
          description:
            "Seamlessly integrates with other SAP modules like MM (Material Management), FI (Financial Accounting), and PP (Production Planning).",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Global Operations",
          description:
            "Supports multiple currencies, languages, and tax configurations, making it suitable for multinational operations.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Automation",
          description:
            "Can automate many sales and distribution processes, leading to efficiency and reduced errors.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Comprehensive Reporting",
          description:
            "Advanced reporting capabilities enable businesses to gain deep insights into sales performance and customer behavior.",
        },
      ],
    },
    "SAP Material Management (SAP MM)": {
      title: "SAP Material Management (SAP MM) Consulting",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title:
            "Allows you to manage master data related to materials, vendors, and purchasing information records.",
          description:
            "Create a single source of truth for insights into all demand by integrating data from sales, customer interactions, market trends, and more.",
        },
        {
          icon: featureImgs[1],
          title: "Purchasing",
          description:
            "Enables you to create purchase requisitions, request for quotations (RFQs), and purchase orders (POs) and manage the entire supply cycle.",
        },
        {
          icon: featureImgs[2],
          title: "Inventory Management",
          description:
            "Provides features to track and manage inventory levels, stock movements, and stock valuation.",
        },
      ],
      content: [
        "SAP MM Module (Material Management)",
        "SAP MM stands for SAP Material Management. It is a module within the SAP ERP (Enterprise Resource Planning) system that focuses on managing purchasing and inventory processes. It plays a critical role in managing end-to-end purchasing and material management activities within an organization.",
        "ts primary objectives are to ensure that materials required for production or services are available at the right time, in the right quantity, and at the right place, while optimizing costs and maintaining high efficiency. It encompasses various processes such as material requirements planning, vendor selection and management, purchase order management, inventory management, goods receipt and issue, invoice verification, and material valuation.",
        "Some key features and functions of SAP MM include:",
        "Master Data Management: SAP MM allows you to manage master data related to materials, vendors, and purchasing information records. This data forms the basis for various purchasing processes.",
        `Purchasing: SAP MM enables you to create purchase requisitions, request for quotations (RFQs), and purchase orders (POs) and manage the entire supply cycle. It supports different types of purchasing, such as direct procurement, subcontracting, and external service procurement.`,
        "Inventory Management: It provides features to track and manage inventory levels, stock movements, and stock valuation. You can manage goods receipt, goods issue, stock transfers, and physical inventory management.",
        "Invoice Verification: SAP MM allows you to verify vendor invoices against purchase orders and goods receipts. It helps ensure accurate payment processing and financial control.",
        "Material Valuation: SAP MM supports various valuation methods for materials, such as standard price, moving average price, and FIFO (First In First Out). It assists in determining the value of inventory and the cost of goods sold.",
        "Integration with Other SAP Modules: SAP MM integrates with other modules like SAP FI (Financial Accounting), SAP SD (Sales and Distribution), SAP PP (Production Planning), and SAP WM (Warehouse Management) to facilitate seamless information flow and streamline business processes.",
      ],
      contentImage: "/assests/solutions/sap-mm.jpg",
      features: [
        {
          icon: otherfeatureImgs[0],
          title: "Integration",
          description:
            "Seamlessly integrates with other SAP modules like SD (Sales and Distribution), FI (Financial Accounting), and PP (Production Planning).",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Global Operations",
          description:
            "Supports multiple currencies, languages, and tax configurations, making it suitable for multinational operations.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Automation",
          description:
            "Automates many purchasing and inventory processes, enhancing efficiency and preventing errors.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Comprehensive Reporting",
          description:
            "Advanced reporting capabilities allow businesses to gain in-depth insights into purchasing process performance, material movements, and inventory activities.",
        },
      ],
    },
    "SAP Advanced Available-to-Promise (aATP)": {
      title: "SAP aATP Consulting",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Product Availability Check (PAC)",
          description:
            "It assists in determining when and how much demand for a specific material can be met based on a specific control rule and the current supply situation.",
        },
        {
          icon: featureImgs[1],
          title: "Back Order Processing (BOP)",
          description:
            "If stock is unavailable for high-priority customer orders, you can fallback to open orders from low-priority customers, cancel confirmations, and allocate the stock to the high-priority customer.",
        },
        {
          icon: featureImgs[2],
          title: "Product Allocation (PAL)",
          description:
            "It aims to help you avoid critical requirements and supply situations. By minimizing production, you can respond quickly to bottlenecks in the market.",
        },
      ],
      content: [
        "SAP Advanced Available-to-Promise (SAP aATP)",
        "SAP Advanced Available-to-Promise (SAP aATP) is a powerful SAP S/4HANA solution that helps businesses optimize demand and inventory management. aATP improves order fulfillment processes by using real-time data to best meet customer demands and fulfill delivery promises. This solution offers businesses the opportunity to enhance customer satisfaction, improve service levels, and gain a competitive advantage.",
        "What are the advantages of SAP aATP?",
        "Product Availability Check (PAC): Assists in determining when and how much demand for a specific material can be met based on a specific control rule and the current supply situation.",
        "Back Order Processing (BOP): If stock is unavailable for high-priority customer orders, you can fallback to open orders from low-priority customers, cancel confirmations, and allocate the stock to the high-priority customer.",
        `Product Allocation (PAL): Aims to help avoid critical requirements and supply situations. By minimizing production, you can respond quickly to bottlenecks in the market.`,
        "Alternative-Based Confirmations (ABC): If a material is insufficient in a specific material-plant combination, you can check all alternatives using ABC.",
        "Release for Delivery (RefDy): You can make Fiori-based interactive changes before releasing orders for delivery.",
        "Product Substitution: With the Product Substitution feature, you can define and maintain substitute products. If a substitute product serves the same function and meets business requirements, you can choose to use or procure substitute products.",
      ],
      contentImage: "/assests/solutions/sap-apt.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Increase Customer Satisfaction",
          description:
            "SAP aATP enhances customer satisfaction by accurately presenting delivery schedules to customers, earning loyalty for your company.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Efficient Order Management",
          description:
            "SAP aATP seamlessly operates in multichannel order fulfillment systems, improving order management, optimizing stock allocations, and streamlining order processes to increase profitability.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Stock Optimization",
          description:
            "SAP aATP optimizes stocks, responds quickly to business needs, and increases profit margins.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Gain Competitive Advantage",
          description:
            "Utilize SAP aATP to optimize stocks and increase your profit margins, gaining a competitive advantage.",
        },
      ],
    },
    "SAP Business Technology Platform (SAP BTP)": {
      title: "SAP Business Technology Platform (SAP BTP)",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Data Excellence",
          description:
            "Data ExcellenceSAP BTP can collect, store, and analyze large amounts of information in real-time from various sources.",
        },
        {
          icon: featureImgs[1],
          title: "Application Development",
          description: "Application Development",
        },
        {
          icon: featureImgs[2],
          title: "Integration and Extension",
          description: "Integration and Extension.",
        },
      ],
      content: [
        "Integration and Extension",
        "SAP Business Technology Platform (BTP) is a platform that provides businesses with the tools, services, and technologies they need in their digital transformation journeys. This platform enables robust data management, rapid application development, integration of business processes, and the utilization of intelligent technologies. Features and Benefits of SAP BTP:",
        "Data Excellence: SAP BTP focuses on data management and analytics, allowing businesses to better understand their data and transform it into value. You can analyze your data in real-time, optimize business processes, and make more informed decisions.",
        "Application Development and Integration: The platform facilitates the development and integration of cloud-based or on-premise applications. SAP enables seamless integration with non-SAP and third-party solutions, allowing you to enhance your business processes and quickly adapt to changing needs.",
        `Analytics and Business Intelligence: SAP BTP simplifies data analysis and the creation of business intelligence solutions. You can visualize your data, track trends, monitor performance, and make data-driven decisions.`,
        "Intelligent Technologies: The platform provides access to intelligent technologies such as artificial intelligence, IoT, and blockchain. By leveraging these technologies, you can optimize business processes, increase efficiency, and enhance the customer experience.",
      ],
      contentImage: "/assests/solutions/sap-bpt.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Full Integration",
          description:
            "Sealkloud seamlessly integrates your business processes using the complete integration feature provided by SAP BTP. This allows you to easily share data across different platforms and optimize your business processes.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Data Management",
          description:
            "Sealkloud guides you in data management with SAP BTP. It helps you organize, analyze, and evaluate your data using best practices, enabling you to make more informed decisions.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Analytical Power",
          description:
            "Sealkloud visualizes your business data using SAP BTP's analytical capabilities. It presents your data with insightful reports and visual graphics, allowing you to better track trends and opportunities.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Customization and Development",
          description:
            "Sealkloud assists you in fully leveraging the application development capabilities offered by SAP BTP. It develops custom applications for your business and customizes existing applications, optimizing your business processes and increasing efficiency.",
        },
      ],
    },
    "SAP FIORI": {
      title: "SAP FIORI",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "User-Friendly Interface",
          description:
            "SAP Fiori provides users with the opportunity to easily manage complex business processes through its modern design and simple user experience.",
        },
        {
          icon: featureImgs[1],
          title: "Productivity and Efficiency",
          description:
            "SAP Fiori is designed to execute processes more quickly and efficiently.",
        },
        {
          icon: featureImgs[2],
          title: "Flexible and Mobile Compatibility",
          description:
            "SAP Fiori provides an effective user experience on mobile devices as well. With mobile compatibility, users can access and manage business processes from anywhere and any device they prefer.",
        },
      ],
      content: [
        "SAP Fiori",
        "SAP Fiori is a modern and user-friendly interface platform developed by SAP for its business applications. Primarily, it is designed to enhance user experience by simplifying complex business processes. Fiori's mobile compatibility allows employees to access and manage data and business processes from anywhere, increasing the flexibility and efficiency of business processes.",
        "User-Friendly Interface: SAP Fiori provides an intuitive and easy-to-understand interface, allowing users to easily manage complex business processes.",
        "Increased Productivity: Simplified processes and quick access help users perform their tasks faster and more efficiently.",
        "Mobile Compatibility: Being fully compatible with mobile devices, SAP Fiori allows users to access and manage business processes from anywhere and any device",
        `Mobile Compatibility: Being fully compatible with mobile devices, SAP Fiori allows users to access and manage business processes from anywhere and any device`,
        "Integration and Flexibility: SAP Fiori seamlessly integrates with other SAP applications, enhancing the flexibility and scope of business processes.",
        "Enhanced Data Security: SAP Fiori ensures the security of corporate data with robust security protocols.",
      ],
      contentImage: "/assests/solutions/sap-fiori.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Custom Fiori Application Development",
          description:
            "Sealkloud develops customized SAP Fiori applications tailored to the specific needs of its customers. This provides user experiences and functionalities designed to meet the unique requirements of business processes.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Fiori User Interface Design and Integration",
          description:
            "Sealkloud designs user-friendly and intuitive Fiori user interfaces and seamlessly integrates these interfaces with existing SAP systems. This allows users to utilize systems more efficiently and effectively.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Mobile Compatibility and Accessibility",
          description: "Mobile Compatibility and Accessibility",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Mobile Compatibility and Accessibility",
          description:
            "Sealkloud ensures the continuous support and maintenance of Fiori applications with ongoing technical support services. This ensures that applications remain up-to-date and functional, contributing to customers' seamless experiences in their business processes.",
        },
      ],
    },
    "SAP ABAP": {
      title: "SAP ABAP",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "Custom Solution Development",
          description:
            "SAP ABAP consultants develop customized applications tailored to the specific needs and business processes of the customer.",
        },
        {
          icon: featureImgs[1],
          title: "Expertise",
          description:
            "This expertise enables the effective management of complex business processes and data, optimizing the stability and performance of systems.",
        },
        {
          icon: featureImgs[2],
          title: "System Integration and Optimization",
          description:
            "Consultants ensure the integration of ABAP solutions with existing SAP modules and external systems while optimizing their performance.",
        },
      ],
      content: [
        "SAP ABAP Consultancy",
        "SAP ABAP is a programming language developed by SAP, used to customize and extend business processes and applications in various modules. SAP ABAP programming creates applications that meet the specific needs of businesses, and ABAP consultancy supports the strategic and technical aspects of this process, ensuring that businesses make the most of their SAP investments. In SAP ABAP Consultancy:",
        "Application Development: Custom applications are developed to optimize business processes for the customer.",
        "Increased Efficiency: Simplified processes and quick access help users perform their tasks faster and more efficiently.",
        "System Integration: Integrates SAP modules within SAP or with non-SAP applications.",
        `Database Management: Application development is done using the existing SAP system database.`,
        "Performance Optimization: Provides solutions to enhance system stability and speed.",
        "Advanced Data Security: Ensures the security of corporate data with robust security protocols.",
        "User-Friendly and Manageable: Fiori provides an easily manageable platform for IT departments, leading to low maintenance costs.",
        "User Satisfaction and Loyalty: A user-friendly interface increases employee satisfaction and loyalty to the system.",
        "Continuous Improvement and Innovation: SAP continually updates Fiori, adding new features and functionalities, making it easy for businesses to adapt to their evolving needs.",
      ],
      contentImage: "/assests/solutions/sap-abap.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "SAP ABAP Consultancy Experience",
          description:
            "Our SAP ABAP consultancy experience enables effective management and customization of the complex aspects of your business's SAP systems, enhancing the efficiency and effectiveness of your business processes.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Custom Solution Development",
          description:
            "Understanding the unique requirements of your business, we design and develop custom business processes and applications, providing your business with a competitive advantage.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Integration and System Optimization",
          description:
            "SAP and non-SAP system integrations ensure the smooth and efficient operation of business processes, enhancing overall business performance.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Continuous Support and Training",
          description:
            "Providing comprehensive support and training at every stage of the project, we ensure the effective use of ABAP solutions in your business and assist in overcoming technical challenges.",
        },
      ],
    },
    "SAP BASIS": {
      title: "SAP BASIS",
      mainfeatures: [
        {
          icon: featureImgs[0],
          title: "System Management and Monitoring",
          description:
            "SAP Basis provides real-time data to system administrators, enabling them to monitor system performance, detect errors, and minimize downtime.",
        },
        {
          icon: featureImgs[1],
          title: "Update and Maintenance Management",
          description:
            "SAP Basis ensures that systems stay up-to-date and regularly maintains databases.",
        },
        {
          icon: featureImgs[2],
          title: "Authorization and Security Management",
          description:
            "Specialized in user authorization and security, SAP Basis ensures protection against cyber threats and addresses security vulnerabilities.",
        },
      ],
      content: [
        "SAP Basis",
        "SAP Basis is a critical component that ensures the smooth and efficient operation of all SAP systems in your business. This foundational structure performs a range of critical tasks, from SAP system installation and configuration to updates and authorization processes. Here are some significant reasons why you should choose SAP Basis services:",
        "System Monitoring and Performance Improvement: SAP Basis monitors your SAP systems 24/7, identifying potential issues in advance, optimizing your system performance, and minimizing downtime.",
        "Staying Up-to-Date and Database Management: SAP Basis ensures that your system remains current and secure, organizing database management, updates, and maintenance processes.",
        `System Maintenance and Repair: System maintenance is crucial to ensuring the smooth operation of your SAP systems. Basis conducts system maintenance and provides quick solutions.`,
        "SAP System Management: Our experienced consultants enhance system performance, perform system copies, upgrade SAP and database versions, provide third-party system integrations, and more.",
        "Authorization Projects: Basis offers consultancy on user authorization and security, safeguarding your systems against unauthorized access.",
      ],
      contentImage: "/assests/solutions/sap-basis.jpg",
      features: [
        {
          icon: otherfeatureImgs[1],
          title: "Comprehensive System Management",
          description:
            "Sealkloud delivers comprehensive system management in SAP Basis services, effectively managing SAP systems, monitoring performance, and quickly resolving issues. It supports system administrators with real-time data and analyses, helping businesses run their SAP environments smoothly.",
        },
        {
          icon: otherfeatureImgs[0],
          title: "Update and Maintenance Management",
          description:
            "Sealkloud ensures that SAP systems remain current and undergo regular maintenance. This helps businesses keep their SAP systems in compliance with the latest security regulations. Sealkloud also plans and executes system maintenance and repairs, ensuring business continuity and data integrity.",
        },
        {
          icon: otherfeatureImgs[2],
          title: "Data Security and Authorization",
          description:
            "Sealkloud meticulously manages data security and authorization processes for SAP systems. It ensures that users have the correct permissions and organizes authorization policies. Additionally, it secures systems against cyber threats and prevents security vulnerabilities.",
        },
        {
          icon: otherfeatureImgs[1],
          title: "Performance Improvement and Optimization",
          description:
            "Sealkloud continuously monitors the performance of SAP systems, identifies improvement opportunities, and ensures businesses get the maximum efficiency from their SAP systems. Sealkloud also provides scalability and capacity management when needed.",
        },
      ],
    },
  };

  return dummyData[slug] || "No data available";
};

export default SolutionsIndividualPage;
